export function smallestToBaseUnitCurrencyFormat(value) {
  return parseFloat(value / 100).toFixed(2);
}



// WEBPACK FOOTER //
// ./src/views/payment/utils.js